import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { PaginatedContent } from "../../../../api/common.types";
import { AccountFilter, Filter, Negotiation, NegotiationStatus } from "../../home-admin-data/account.types";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { AccountService } from "../../home-admin-data/account.service";
import { take } from "rxjs";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { AccountType } from "../../../login-page/login-page-data/login.types";
import { FilterStorageService } from "../../../../api/filter-storage/filter-storage.service";
import { FiltersPage } from "../../../../api/filter-storage/filter-storage.types";
import { NzModalService } from "ng-zorro-antd/modal";
import { TableStateManager } from "../../utils/table-state-manager";
import { NegotiationDetailsDialogComponent } from "../../../../../../../common-ui/src/lib/negotiation-details-dialog/negotiation-details-dialog.component";

const FILTERS_PAGE = FiltersPage.NEGOTIATIONS;

@Component({
  selector: "mh-admin-negotiation-list",
  templateUrl: "./admin-negotiation-list.component.html",
  styleUrls: ["./admin-negotiation-list.component.less"],
})
export class AdminNegotiationListComponent implements OnInit {
  tableState = new TableStateManager<Negotiation>((filter) => this.accountService.loadNegotiationsList(filter));
  searchForm!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private accountService: AccountService,
    private filterStorageService: FilterStorageService,
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchTerm: [null],
      negotiationStatuses: [NegotiationStatus.COMPLETED],
    });

    const storedFilters = this.filterStorageService.getStoredFilters()?.[FILTERS_PAGE];
    if (storedFilters) {
      this.searchForm.patchValue(storedFilters);
    }

    this.tableState.fetchData({ ...this.getDefaultQueryParams(), ...this.getFilterFormValues() });
  }

  onPageChange(pageIndex: number): void {
    this.tableState.onPageChange(pageIndex, () => this.getFilterFormValues());
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.tableState.onQueryParamsChange(params, () => this.getFilterFormValues());
  }

  submitFilterForm(): void {
    this.filterStorageService.saveFilters(this.searchForm, FILTERS_PAGE);
    this.tableState.onQueryChange({
      paging: {
        page: 1,
        itemsOnPage: this.tableState.data?.paging?.itemsOnPage || 0,
      },
      ...this.getFilterFormValues(),
    });
  }

  getFilterFormValues() {
    const searchField = this.getSearchField("searchTerm");
    const negotiationStatuses = this.getSearchField("negotiationStatuses");

    const filterFormValues = {
      searchTerm: searchField?.value || "",
      filters: [] as Filter[],
    };

    if (negotiationStatuses?.value) {
      filterFormValues.filters.push({
        value: negotiationStatuses.value,
        field: "STATUS",
      });
    }

    return filterFormValues;
  }

  getSearchField(name: string) {
    return this.searchForm.get(name);
  }

  getDefaultQueryParams() {
    return {
      paging: {
        page: 1,
        itemsOnPage: 50,
      },
      searchTerm: "",
    };
  }

  openNegotiationDetailsModal(negotiation: Negotiation) {
    const modal = this.modal.create({
      nzContent: NegotiationDetailsDialogComponent,
      nzMaskClosable: false,
      nzViewContainerRef: this.viewContainerRef,
      nzData: { negotiation },
      nzWidth: "800px",
    });
  }

  protected readonly NegotiationStatus = NegotiationStatus;
  protected readonly AccountType = AccountType;
}
